import { Suspense } from 'react';

/**
 * Suspense boundary for code-split pages.
 *
 * A leaf both the router and the sector modules import: the router folds
 * over the module registry, so a module importing this from `router.tsx`
 * would close a cycle.
 */
export function LazyPage({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="p-8 text-center text-sm text-slate-500">Chargement…</div>
      }
    >
      {children}
    </Suspense>
  );
}
